import { useState, useMemo } from "react";
import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router-dom";

const useLoginPopup = () => {
  const { userDetails } = useAuth();
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(true);

  const userBusinessProfile = useMemo(() => {
    try {
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      return userData?.userDetails?.userBusinessProfile ?? null;
    } catch {
      return null;
    }
  }, []);

  // const shouldShowPopup = useMemo(() => {
  //   if (!userBusinessProfile) return false;

  //   const userRole = userDetails?.userRole;

  //   if (userRole !== "Buyer" && userRole !== "Seller") return false;

  //   if (sessionStorage.getItem("loginPopupDismissed") === "true") return false;

  //   if (!isVisible) return false;

  //   const { completedQuestions, numberOfQuestions, hasBeenAYear } =
  //     userBusinessProfile;

  //   const isIncomplete =
  //     completedQuestions < numberOfQuestions ||
  //     (completedQuestions === 0 && numberOfQuestions === 0);
  //   const needsYearlyUpdate = hasBeenAYear === true;

  //   return isIncomplete || needsYearlyUpdate;
  // }, [userBusinessProfile, userDetails, isVisible]);

  const shouldShowPopup = false;
  const dismissPopup = () => {
    sessionStorage.setItem("loginPopupDismissed", "true");
    setIsVisible(false);
  };

  const navigateToProfile = () => {
    const hasBeenAYear = userBusinessProfile?.hasBeenAYear === true;
    dismissPopup();
    navigate(`/profile/${userDetails?.userId}/business-profile`, {
      state: { hasBeenAYear },
    });
  };

  const progress = useMemo(() => {
    if (!userBusinessProfile) {
      return { completedQuestions: 0, numberOfQuestions: 0, percentage: 0 };
    }

    const { completedQuestions = 0, numberOfQuestions = 0 } =
      userBusinessProfile;
    const percentage =
      numberOfQuestions > 0
        ? Math.round((completedQuestions / numberOfQuestions) * 100)
        : 0;

    return { completedQuestions, numberOfQuestions, percentage };
  }, [userBusinessProfile]);

  return {
    shouldShowPopup,
    dismissPopup,
    navigateToProfile,
    progress,
  };
};

export default useLoginPopup;
